/**
 * Translate between stored logo geometry (PDF points, bottom-left origin — what
 * pdf-lib draws with) and on-screen pixels (top-left origin — how the react-pdf
 * canvas lays out an absolutely-positioned overlay).
 *
 * `scale` = renderedPx / pagePoints ; `pageHeightPt` = page height in PDF points.
 */

// Stored PDF-point logo -> screen box (px) for the overlay.
export function pdfToScreen(logo, scale, pageHeightPt) {
  return {
    left: logo.x * scale,
    top: (pageHeightPt - logo.y - logo.height) * scale,
    width: logo.width * scale,
    height: logo.height * scale,
  };
}

// Screen box (px) from the overlay -> stored PDF-point geometry.
export function screenToPdf({ left, top, width, height }, scale, pageHeightPt) {
  const w = width / scale;
  const h = height / scale;
  return {
    x: left / scale,
    y: pageHeightPt - top / scale - h,
    width: w,
    height: h,
  };
}
